import gql from 'not-graphql-tag';

export const getAccountDetailsQuery = gql`
  query getAccountDetails(
    $params: AccountDetailParams!
    $isTPAFeatureEnabled: Boolean!
  ) {
    getAccountDetails(params: $params) {
      accountType
      currentCharges {
        amountDue
      }
      nextBill {
        billDate
      }
      mailingAddress {
        addressLine1
        city
        state
        postal
      }
      premiseInfo {
        addressLine1
        addressLine2
        city
        state
        postal
      }
      tpa @include(if: $isTPAFeatureEnabled) {
        isEligible
        isEnrolled
        accountBalance
        recommendedPaymentMonths
        enrolledInstallmentDetails {
          payOffAmount
          currentTpaMonthBalance
          totalMonths
          monthsMatrix {
            monthNumber
            isPaymentCompleted
            paymentDate
            monthlyAmount
            doesBillExist
          }
        }
      }
    }
  }
`;

export const enrollTPAMutation = gql`
  mutation enrollTpa($payload: TPA_EnrollInput!) {
    enrollTpa(payload: $payload) {
      confirmationNumber
      enrolledInstallmentDetails {
        payOffAmount
        currentTpaMonthBalance
        totalMonths
        monthsMatrix {
          monthNumber
          isPaymentCompleted
          paymentDate
          monthlyAmount
          doesBillExist
        }
      }
    }
  }
`;
export const getAccountDetailsBillDetailsQuery = gql`
  query getAccountDetails($params: AccountDetailParams!) {
    getAccountDetails(params: $params) {
      currentCharges {
        amountDue
      }
      isSummaryBillAccount
      billInfo {
        billDetails {
          encryptedBillId
          downloadBillUrl
          billStatus
          billDate
          dueDate
          amountDue
          previousBalance
          totalAdjustments
          totalCurrentCharges
          totalBalanceAfterBill
          hasBills
          kwh
          billingPeriodStartDate
          billingPeriodEndDate
        }
        amountDue
      }
    }
  }
`;
